let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("5465r"), load("fkY2m"), load("6wr18"), load("ffEVr"), load("f9WnJ")]).then(() => parcelRequire('gVFlX'));